"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./BuySellComponent.css");
var _BuySellOrderConfirmationModal = _interopRequireDefault(require("../BuySellOrderConfirmationModal"));
var _BuySellTabs = _interopRequireDefault(require("./BuySellTabs"));
var _BuySellInstrumentSelector = _interopRequireDefault(require("./BuySellInstrumentSelector"));
var _BuySellOrderButton = _interopRequireDefault(require("./BuySellOrderButton"));
var _BuySellPresetValuesRows = _interopRequireDefault(require("./BuySellPresetValuesRows"));
var _BuySellCustomRow = _interopRequireDefault(require("./BuySellCustomRow"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('buy-sell');
var BuySellComponent = /*#__PURE__*/function (_React$Component) {
  function BuySellComponent() {
    _classCallCheck(this, BuySellComponent);
    return _callSuper(this, BuySellComponent, arguments);
  }
  _inherits(BuySellComponent, _React$Component);
  return _createClass(BuySellComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        extraInfoComponent = _this$props.extraInfoComponent,
        displayInstrumentSelector = _this$props.displayInstrumentSelector,
        themeModifier = _this$props.themeModifier,
        amountHeader = _this$props.amountHeader,
        formHeader = _this$props.formHeader,
        hideKYC = _this$props.hideKYC,
        customKYCmessage = _this$props.customKYCmessage;
      return /*#__PURE__*/_react["default"].createElement("form", {
        className: baseClasses('container', themeModifier),
        onSubmit: handleSubmit
      }, formHeader && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-header', themeModifier)
      }, formHeader), /*#__PURE__*/_react["default"].createElement(_BuySellTabs["default"], {
        baseClasses: baseClasses,
        themeModifier: themeModifier
      }), displayInstrumentSelector && /*#__PURE__*/_react["default"].createElement(_BuySellInstrumentSelector["default"], {
        baseClasses: baseClasses
      }), amountHeader && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('amount-header', themeModifier)
      }, t(amountHeader)), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('amount-container', themeModifier)
      }, /*#__PURE__*/_react["default"].createElement(_BuySellPresetValuesRows["default"], {
        baseClasses: baseClasses
      }), /*#__PURE__*/_react["default"].createElement(_BuySellCustomRow["default"], {
        baseClasses: baseClasses,
        themeModifier: themeModifier
      }), /*#__PURE__*/_react["default"].createElement(_BuySellOrderConfirmationModal["default"], null)), extraInfoComponent && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('extra-info-container', themeModifier)
      }, extraInfoComponent), /*#__PURE__*/_react["default"].createElement(_BuySellOrderButton["default"], {
        baseClasses: baseClasses,
        handleSubmit: handleSubmit,
        submitting: submitting,
        hideKYC: hideKYC,
        customKYCmessage: customKYCmessage
      }));
    }
  }]);
}(_react["default"].Component);
BuySellComponent.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired,
  displayInstrumentSelector: _propTypes["default"].bool,
  extraInfoComponent: _propTypes["default"].element,
  themeModifier: _propTypes["default"].string,
  submitting: _propTypes["default"].bool.isRequired,
  hideKYC: _propTypes["default"].bool,
  customKYCmessage: _propTypes["default"].string
};
BuySellComponent.defaultProps = {
  displayInstrumentSelector: true,
  hideKYC: false,
  amountHeader: 'Amount'
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(BuySellComponent);